import type { Tokens } from '@zeus/themes';

export function createRatingStyles(tokens: Tokens) {
  return {
    MuiRating: {
      styleOverrides: {
        root: {
          '.MuiRating-iconEmpty': {
            color: tokens.ui.rating.inactive.foreground,
          },
          '.MuiRating-iconFilled': {
            color: tokens.ui.rating.active.foreground,
          },
        },
      },
    },
  };
}
